import Header from "./components/Header";
import Footer from "./components/Footer";
import React from "react";
import Numbers from "./components/Numbers";
import Features from "./components/Features";
import Reviews from "./components/Reviews";
import Galery from "./components/Galery";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import MapAndContactSection from "./components/MapAndContactSection";

class App extends React.Component {


  constructor(props) {
    super(props);
    this.headerRef = React.createRef();
    this.numbersRef = React.createRef();
    this.featuresRef = React.createRef();
    this.galleryRef = React.createRef();
    this.reviewsRef = React.createRef();
    this.mapRef = React.createRef();
    this.state = {
      isModalOpen: false,
      numbers: [
        {
          id: 1,
          title: 'Люкс',
          img: 'lux.jpg',
          square: '40',
          price: 'от 3000 рублей' ,
          desc: 'Рассчитан на тех кто любит отдыхать по-максимуму, не отказывая себе ни в чем. Людям, ценящим комфорт и простор больше всего.'
        },
        {
          id: 2,
          title: 'Стандарт',
          img: 'standart.jpg',
          square: '25',
          price: 'от 2000 рублей',
          desc: 'Уютный, комфортный и довольно просторный. Несомненный плюс стандартного номера на 2-м этаже - большой балкон с видом на море.' 
        },
        {
          id: 3,
          title: 'Эконом',
          img: 'ekonom.jpg',
          square: '40',
          price: 'от 2000 рублей',
          desc: 'Номер для тех, кто хочет сэкономить, но без комфортом и удобством. В номере 5 раздельных односпальных кроватей с общим санузлом.'
        }
      ],
       
      reviewData: [
        {
          author: 'Евгений М.',
          date: '11.01.25',
          image: 'img/building.jpg',
          text: 'Однозначно рекомендую! Хозяйка Наталья очень гостеприимна, добродушная, встречает как родных) В номере ЧИСТОТА, с балкона потрясный вид на море, город, крымский мост. Все очень здорово! Только теплые воспоминания от пребывания в Керчи',
        },
        {
          author: 'Марина Ц.',
          date: '12.10.24',
          image: 'img/marina.jpg',
          text: 'Останавливались с мужем на ночь в Керчи, за неделю до поездки забронировала номер с кухней. Гостиница располагается в историческом центре, колоритные улочки, дома. Номер с отдельной террасой, просторный, удобный, с кухней( правда, мы не воспользовались), доброжелательный персонал, забавный мопсик😊.Наталия, хозяйка, встретила, рассказала, где можно вкусно поужинать; утром, на завтрак, предложила кофе. Уезжали в самом лучшем настроении. Спасибо огромное, обязательно вернемся в Эдельвейс',
        },
        {
          author: 'Юлия К.',
          date: '25.11.24',
          image: 'img/yuliya.jpg',
          text: 'Чудесный отель, радушная хозяйка. При выборе переживала, что придётся высоко подниматься или блукать в переулках, но оказалось все очень комфортно. Подниматься не сложнее, чем на третий этаж, но по царской митридатской лестнице, которая после реконструкции выглядит потрясающе, в том числе с подсветкой ночью. Отель находится практически возле лестницы. В номере есть всё необходимое, просторные и при этом уютные номера. Вид из отеля на весь пролив и мост.',
        },
        {
          author: 'Владимир Т.',
          date: '27.02.23',
          image: 'img/comment.jpg',
          text: 'Эдельвейс. Великолепный небольшой отель. В историческом центре. В шаговой доступности Пантикапея, раскопки древнего города VI век до нашей эры. Доброжелательные хозяева и персонал. Большие и чистые номера с балконами. Со двора виден Митридат с балкона Крымский мост. Были с женой в конце февраля. Тёплые номера, большой шкаф для одежды и вещей. Есть стоянка для автомобилей.',
        }
      ],
      
    }
  }

  openModal = () => {
    this.setState({ isModalOpen: true });
  };

  // Метод для закрытия модального окна
  closeModal = () => {
    this.setState({ isModalOpen: false });
  };

  scrollToSection = (ref) => {
    ref.current.scrollIntoView({ behavior: 'smooth' });
  };

  componentDidMount() {

    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href =
      "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css";
    document.head.appendChild(link);


    document.addEventListener('keydown', this.handleKeyPress);

    console.log('Refs status:', {
      header: this.headerRef.current,
      numbers: this.numbersRef.current,
      features: this.featuresRef.current,
      gallery: this.galleryRef.current,
      reviews: this.reviewsRef.current,
      map: this.mapRef.current
    });
  }
  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyPress);
  }

  handleKeyPress = (event) => {
    const sections = [
      this.headerRef,
      this.numbersRef,
      this.featuresRef,
      this.galleryRef,
      this.reviewsRef,
      this.mapRef
    ];
  
    // Найдем текущую видимую секцию
    const currentSectionIndex = sections.findIndex(ref => {
      const rect = ref.current.getBoundingClientRect();
      return rect.top <= 100 && rect.bottom > 0;
    });
  
    switch(event.key) {
      case 'ArrowUp':
        if (currentSectionIndex > 0) {
          this.scrollToSection(sections[currentSectionIndex - 1]);
        }
        break;
      case 'ArrowDown':
        if (currentSectionIndex < sections.length - 1) {
          this.scrollToSection(sections[currentSectionIndex + 1]);
        }
        break;
      default:
        break;
    }
  };
  render () {


    return (
      <>
        <ToastContainer />
        <div className="wrapper">
          <div ref={this.headerRef} className="section header-section">
            <Header scrollToSection={this.scrollToSection} mapRef={this.mapRef} />
            <div className="scroll-arrows">
              <div className="scroll-arrow-down" onClick={() => this.scrollToSection(this.numbersRef)}>
                ↓
              </div>
            </div>
          </div>

          <div ref={this.numbersRef} className="section">
            <Numbers numbers={this.state.numbers} />
            <div className="scroll-arrows">
              <div className="scroll-arrow-up" onClick={() => this.scrollToSection(this.headerRef)}>
                ↑
              </div>
              <div className="scroll-arrow-down" onClick={() => this.scrollToSection(this.featuresRef)}>
                ↓
              </div>
            </div>
          </div>

          <div ref={this.featuresRef} className="section features-section">
            <Features />
            <div className="scroll-arrows">
              <div className="scroll-arrow-up" onClick={() => this.scrollToSection(this.numbersRef)}>
                ↑
              </div>
              <div className="scroll-arrow-down" onClick={() => this.scrollToSection(this.galleryRef)}>
                ↓
              </div>
            </div>
          </div>

          <div ref={this.galleryRef} className="section">
            <Galery />
            <div className="scroll-arrows">
              <div className="scroll-arrow-up" onClick={() => this.scrollToSection(this.featuresRef)}>
                ↑
              </div>
              <div className="scroll-arrow-down" onClick={() => this.scrollToSection(this.reviewsRef)}>
                ↓
              </div>
            </div>
          </div>

          <div ref={this.reviewsRef} className="section">
            <Reviews reviews={this.state.reviewData} />
            <div className="scroll-arrows">
              <div className="scroll-arrow-up" onClick={() => this.scrollToSection(this.galleryRef)}>
                ↑
              </div>
              <div className="scroll-arrow-down" onClick={() => this.scrollToSection(this.mapRef)}>
                ↓
              </div>
            </div>
          </div>

          <div ref={this.mapRef} className="section">
          <MapAndContactSection />
            <div className="scroll-arrows">
              <div className="scroll-arrow-up" onClick={() => this.scrollToSection(this.reviewsRef)}>
                ↑
              </div>
            </div>
          </div>

          <Footer />
        </div>
      </>
    );
  }
  
}

export default App;
